import { Outlet } from 'react-router-dom';
import AdminHeader from '../header/AdminHeader';

function RouteWithAdminHeader() {
	return (
		<>
			<AdminHeader />
			<main>
				<Outlet />
			</main>
		</>
	);
}

export default RouteWithAdminHeader;
